jQuery(document).ready(function () {

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
      $(".main-header").addClass("sticky_header");
    } else {
      $(".main-header").removeClass("sticky_header");
    }

  });


  setTimeout(function() { 
    jQuery(".template-index .main-header nav.full .nav-item").hover(
      function () {
        jQuery('.template-index .main-header').addClass("hv_menu_bg");
      },
      function () {
        jQuery('.template-index .main-header').removeClass("hv_menu_bg");
      }
    );
 
  }, 4000);

  setTimeout(function() { 
    jQuery(".template-index .main-header nav.full .nav-item").hover(
      function () {
        jQuery('.template-index .main-header').addClass("hv_menu_bg");
      },
      function () {
        jQuery('.template-index .main-header').removeClass("hv_menu_bg");
      }
    );

  }, 5000);


  setTimeout(function() { 
    jQuery(".template-index .main-header nav.full .nav-item").hover(
      function () {
        jQuery('.template-index .main-header').addClass("hv_menu_bg");
      },
      function () {
        jQuery('.template-index .main-header').removeClass("hv_menu_bg");
      }
    );

  }, 6000);
  setTimeout(function() { 
    jQuery(".template-index .main-header nav.full .nav-item").hover(
      function () {
        jQuery('.template-index .main-header').addClass("hv_menu_bg");
      },
      function () {
        jQuery('.template-index .main-header').removeClass("hv_menu_bg");
      }
    );

  }, 7000);

});


//     jQuery(".video_sec_btn").click(function() {
//       jQuery('.video_playbtn').css({
//           'opacity': '0',
//           'visibility': 'hidden'
//       });
//       jQuery(".slider_Video").trigger('play');
//       jQuery('.video_pausebtn').css({
//           'opacity': '1',
//           'visibility': 'visible'
//       });
//       if (video.paused) {
//         video.play();
//          btn.innerHTML = "Pause";
//       } else {
//         video.pause();
//         btn.innerHTML = "Play";
//       }
      

//   });
jQuery('.video_pausebtn').hide();
jQuery(document).on('click', '.video_sec_btn', function(e) {
  var video = jQuery('.slider_Video').get(0);
  if (video.paused === false) {
        jQuery('.video_pausebtn').hide();
    jQuery('.video_play_btn').show();
    video.pause();

  } else {
         jQuery('.video_pausebtn').show();
    jQuery('.video_play_btn').hide();
    video.play();
  }
  return false;
  
    
});

// Tabs Function
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
var tab_click = document.querySelector("#defaultOpen");
if(tab_click){
  tab_click.click();
}

jQuery(document).ready(function(){
  //  Home Main Slider 
  var swiper = new Swiper('.swiper_slider_container', {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
//     loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
   },
  });

  // Product Mobile Slider
  var swiper = new Swiper('.swiper-mobilegallery', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

  });

  // Collection Page Secound Video Play or Pause Script
  jQuery('.product-card-figure').mouseover(function(){
    jQuery(this).find('.product-single__video video').get(0).play();
    jQuery(this).find('.product-single__video audio').get(0).play(); // Play hover sound
  }).mouseout(function(){
    jQuery(this).find('.product-single__video video').get(0).pause();
    jQuery(this).find('.product-single__video audio').get(0).pause(); // Pause hover sound
  });
});